import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface BookCTASectionProps {
  id?: string;
  heading?: string;
  subheading?: string;
}

const BookCTASection = ({
  id = "book",
  heading = "Book Your Cabana",
  subheading = "Reserve your private cabana online in minutes.",
}: BookCTASectionProps) => {
  return (
    <section
      id={id}
      style={{ scrollMarginTop: "96px" }}
      className="scroll-mt-24 py-16 md:py-20 bg-primary/5"
    >
      <div className="container mx-auto px-4 text-center">
        <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-3">{heading}</h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8">{subheading}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button asChild size="lg">
            <Link to="/book-now">Reserve Your Cabana</Link>
          </Button>
          <Button asChild size="lg" variant="outline">
            <a href="#pricing">See Pricing</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BookCTASection;